import { render, staticRenderFns } from "./ProjectEditorList.vue?vue&type=template&id=a8777a80&scoped=true&"
import script from "./ProjectEditorList.vue?vue&type=script&lang=js&"
export * from "./ProjectEditorList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectEditorList.vue?vue&type=style&index=0&id=a8777a80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8777a80",
  null
  
)

export default component.exports